/**
 * Lightens a hex or rgba color by a given percentage (0-100).
 * @param {string} color - The color string (e.g., '#25282D' or 'rgba(37, 40, 45, 1)').
 * @param {number} percent - The percentage to lighten (e.g., 40 for 40%).
 * @returns {string} The lightened color as an rgb() or rgba() string.
 */
export function lightenColor(color, percent) {
  // Check if the color is in rgba format
  if (color.startsWith('rgba')) {
    const [r, g, b, a] = color
      .match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d*\.?\d+))?\)/)
      .slice(1)
      .map(Number);
    
    const newR = Math.min(255, r + Math.round(2.55 * percent));
    const newG = Math.min(255, g + Math.round(2.55 * percent));
    const newB = Math.min(255, b + Math.round(2.55 * percent));
    
    return `rgba(${newR},${newG},${newB},${a})`;
  }
  
  // Handle hex colors
  let h = color.replace(/^#/, '');
  if (h.length === 3) {
    h = h.split('').map(x => x + x).join('');
  }
  const num = parseInt(h, 16);
  let r = (num >> 16) + Math.round(2.55 * percent);
  let g = ((num >> 8) & 0x00FF) + Math.round(2.55 * percent);
  let b = (num & 0x0000FF) + Math.round(2.55 * percent);
  r = r < 255 ? r : 255;
  g = g < 255 ? g : 255;
  b = b < 255 ? b : 255;
  return `rgb(${r},${g},${b})`;
} 